'use client';

import React from 'react';
import { cn } from '../utils/cn';

export interface DisplayFieldProps {
  name?: string;
  label?: string;
  children: React.ReactNode;
  className?: string;
  isMandatory?: boolean;
}

export function DisplayField({
  name,
  label,
  children,
  className = '',
  isMandatory = false,
}: DisplayFieldProps) {
  return (
    <div className="w-full">
      <div className={cn('flex flex-col md:flex-row gap-1', className)}>
        {label && (
          <label
            htmlFor={name}
            className="block sm:w-[220px] text-12 text-el-grey-500"
          >
            {label}
            {isMandatory && <span className="text-el-red-500">*</span>}
          </label>
        )}

        <div className="flex-1 w-full">
          <div className=" flex items-center text-14 text-el-grey-900">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
